<template>
  <div class="sys-role-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 角色管理 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom" shadow="never">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>

      <c-table
        :index="true"
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
        @authorization="gotoAuthorize"
        @edit="goto"
        @delete="pageDel"
      >
      </c-table>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
      :width="dialogWidth"
    >
      <div
        class="tree-container div-scroll"
        v-if="isTree"
        style="max-height: 500px"
      >
        <el-tree
          :data="menuList"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
        >
        </el-tree>
      </div>

      <div class="div-scroll" v-else style="max-height: 500px; padding: 0 4%">
        <c-form
          v-model="handleData"
          ref="cForm"
          :formRules="formRules"
          :formItems="formItems"
          labelWidth="100px"
          @submit="submit"
          @resetFields="resetFields"
        >
        </c-form>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isTree">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleGetAuthorize">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/roles";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/account/sys/role/list",
  pageDelPath: "/account/sys/role",
  pageDelsPath: "",
  pageParams: {
    platform: "",
    type: "",
  },
});
let mHandle = MHandle({
  handleGetPath: "",
  handleInsertPath: "/account/sys/role/save",
  handleUpdatePath: "/account/sys/role/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      formItems,
      formRules,
      dialogFormVisible: false,
      title: "",
      menuList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      isTree: false,
      dialogWidth: "50%",
      roleId: "",
      defaultHnaldeData: {
        name: "",
        type: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_APP_KEY"]),
  },
  created() {},
  mounted() {
    // 获取授权树数据
    this.getMenuTree();
    this.getPlatformList();
  },
  methods: {
    pageGetBeforeFn(data) {
      data.platform = this._APP_KEY;
      return data;
    },
    // 获取应用标识列表
    getPlatformList() {
      this.$http
        .get("/account/sys/dict/getPlatformList", {
          params: { platform: this._APP_KEY },
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.searchItems[0].options = this.formItems[1].options =
              res.data.map((item) => {
                return {
                  label: item.dictValue,
                  value: item.dictKey,
                };
              });
          }
        });
    },
    // 新增或变更
    goto(data, type) {
      let id = data.id;
      this.isTree = false;
      this.dialogWidth = "50%";
      this.dialogFormVisible = true;
      this.handleData = Object.assign({}, this.defaultHnaldeData);
      this.$nextTick(() => {
        this.$refs.cForm.clearValidate();
      });
      if (id) {
        this.title = "编辑";
        this.handleData = Object.assign({}, data);
      } else {
        this.title = "添加";
      }
    },
    gotoAuthorize(data) {
      let id = data.id;
      this.dialogWidth = "30%";
      this.dialogFormVisible = true;
      this.isTree = true;
      this.title = "角色授权";
      this.roleId = id;
      // 获取当前角色下的菜单列表
      this.$http.get("/account/sys/role/" + id).then((res) => {
        console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          // 设置当前角色的授权列表
          let list = res.data.menuIdList;
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys([]);
            this.$refs.tree.setCheckedKeys(list);
          });
        }
      });
    },
    // 授权操作
    handleGetAuthorize() {
      let idList = this.$refs.tree.getCheckedKeys();
      let halfIdList = this.$refs.tree.getHalfCheckedKeys();
      let params = {
        id: this.roleId,
        idList,
        halfIdList,
        platform: this._APP_KEY,
      };
      this.$http
        .post("/account/sys/role/authorization", params)
        .then((res) => {
          console.log(res);
          this.dialogFormVisible = false;
          if (res.code == this.SUCCESS_CODE) {
            this.$message({
              message: "恭喜你，授权成功！",
              type: "success",
            });
          } else {
            this.$message.error(`授权失败，${res.msg}`);
          }
        })
        .catch((err) => {
          this.dialogFormVisible = false;
          this.$message.error(`授权失败，${res.msg}`);
        });
    },
    // 表格复选框操作（获取选中行）
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {
        platform: this._APP_KEY,
        type: "",
      };
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
    handleDialogClose() {},
    // 新增或编辑数据后的操作
    handleAfterFn() {
      this.dialogFormVisible = false;
      // this.handleData = Object.assign({}, this.defaultHnaldeData);
      this.pageGet(true);
    },
    // 获取授权菜单树
    getMenuTree() {
      this.pageLoading = true;
      this.$http
        .get("/account/sys/menu/getTreeList", {
          params: { platform: this._APP_KEY },
        })
        .then((res) => {
          // console.log(res);
          this.pageLoading = false;
          if (res.code == this.SUCCESS_CODE) {
            this.menuList = res.data;
          } else {
            this.$message.error(`获取数据失败，${res.msg}`);
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          this.$message.error(`获取数据失败，${err}`);
        });
    },
  },
};
</script>

